export default "__VITE_ASSET__BCffVZr4__"